import { ConsoleFacade } from '@/shared/helpers';
import Vue from 'vue';

import * as TypedAgendaItemFileAttachmentModalComponent from '@/public/activity/meeting/components/agenda-item-file-attachment-modal-component/agenda-item-file-attachment-modal-component';
import AgendaItemFileAttachmentModalComponent from '@/public/activity/meeting/components/agenda-item-file-attachment-modal-component/agenda-item-file-attachment-modal-component.vue';

import { IHierarchyNode } from '@/shared/api-client/models/hierarchy-node';
import { IAgendaItem } from '@/shared/api-client/models/agenda/agenda-item';

export class AgendaItemFileAttachmentModalOpener  {

    public static async openAsync(containerElement: Element,
        agendaItem: IHierarchyNode<IAgendaItem>,
        translations: { [key: string]: string; },
        onClosed?: () => any): Promise<void> {

        const ComponentClass = Vue.extend(AgendaItemFileAttachmentModalComponent);

        const instance = new ComponentClass({
            propsData: {
                agendaItem,
                translations
            }
        });

        instance.$mount();

        if (onClosed) {
            instance.$on('closed', onClosed);
        }

        ConsoleFacade.log(`Trying to instantiate agenda item file attachment modal component`, instance, containerElement);

        containerElement.innerHTML = '';

        containerElement.appendChild(instance.$el);

        const typedInstance = instance as TypedAgendaItemFileAttachmentModalComponent.default;

        await typedInstance.open();
    }
}
